import { AuthenticationModel, authenticationModel } from "./Authentication";

export interface StoreModel {
  authentication: AuthenticationModel;
}

export const storeModel = {
  authentication: authenticationModel,
};
